import { useEffect, useState } from 'react';
import { Icon28ChevronUpOutline } from '@vkontakte/icons';

const SHOW_AFTER_PX = 400;

function readTop(target: EventTarget | null): number {
  const deTop = document.scrollingElement?.scrollTop ?? 0;
  const t = target as HTMLElement | null;
  const tTop = t && typeof t.scrollTop === 'number' ? t.scrollTop : 0;
  return Math.max(deTop, tTop);
}

function scrollTopAll() {
  const behavior: ScrollBehavior = 'smooth';
  window.scrollTo({ top: 0, behavior });
  for (const el of Array.from(document.querySelectorAll<HTMLElement>('body *'))) {
    if (el.scrollTop > SHOW_AFTER_PX) el.scrollTo({ top: 0, behavior });
  }
}

/**
 * Floating «scroll to top» button. Renders above TabBar (left of the global
 * back FAB), respects safe-area. Scrolls the document and any scrolled
 * containers back to top.
 */
export function ScrollToTopFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = (e: Event) => setVisible(readTop(e.target) > SHOW_AFTER_PX);
    onScroll(new Event('scroll'));
    window.addEventListener('scroll', onScroll, { passive: true });
    // capture: scroll does not bubble, inner containers still reach document
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('scroll', onScroll, { capture: true });
    };
  }, []);

  if (!visible) return null;

  return (
    <button type="button" className="tp-fab" aria-label="Наверх" onClick={scrollTopAll}>
      <Icon28ChevronUpOutline width={26} height={26} />
    </button>
  );
}
